import dictionary from '../../../../utils/dictionary';
import { makeKey } from '../../../../utils/system';

export default {
  [makeKey(dictionary.bets_allBets)]: 'ALL_BETS',
  [makeKey(dictionary.bets_openBets)]: 'OPEN_BETS',
  [makeKey(dictionary.bets_alreadyPlayed)]: 'ALREADY_PLAYED_BETS',
};
